import { useState } from "react";
import {
  Authenticated,
  AuthLoading,
  Unauthenticated,
} from "convex/react";
import { Loader2 } from "lucide-react";
import type { Id } from "../convex/_generated/dataModel";
import { SignInScreen } from "@/components/auth/SignInScreen";
import { AppShell } from "@/components/chat/AppShell";
import "./index.css";

export function App() {
  const [activeId, setActiveId] = useState<Id<"conversations"> | null>(null);

  return (
    <>
      <AuthLoading>
        <div className="min-h-screen flex items-center justify-center">
          <Loader2 className="size-6 animate-spin text-muted-foreground" />
        </div>
      </AuthLoading>
      <Unauthenticated>
        <SignInScreen />
      </Unauthenticated>
      <Authenticated>
        <AppShell activeId={activeId} setActiveId={setActiveId} />
      </Authenticated>
    </>
  );
}

export default App;
